import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { LoaderService } from './loader.service';

@Injectable({
	providedIn: 'root',
})
export class LoaderInterceptor implements HttpInterceptor {
	constructor(private loaderService: LoaderService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (req.url.includes('chat')) {
			return next.handle(req);
		}
		else {
			this.loaderService.show();
			return next.handle(req).pipe(
				catchError(err => {
					this.loaderService.hide();
					return throwError(err);
				}),
				finalize(() => {
					this.loaderService.hide();
				})
			);
		}

	}
}
